export default "__VITE_ASSET__CIWRxssq__$_?url__"